<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-16 16:59:51
 * @LastEditTime: 2019-09-20 13:34:31
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id="page_Container">
        <div class="page">
            <div id="main-container" class="main-container">
                <div class="top">
                    <!-- 头部显示 -->
                    <div class="income">
                        <van-row>
                            <van-col span="8">
                                <div class="price">¥{{priceInfo.allProfit?priceInfo.allProfit.toFixed(2):'0.00'}}</div>
                                <div class="title">总收益（元）</div>
                            </van-col>
                            <van-col span="8">
                                <div class="price">¥{{priceInfo.todayProfit?priceInfo.todayProfit.toFixed(2):'0.00'}}</div>
                                <div class="title">今日收益（元）</div>
                            </van-col>
                            <van-col span="8" @click.native="toPage('OPWithdrawDetails')">
                                <div class="price">¥{{priceInfo.allowedDrawCash?priceInfo.allowedDrawCash.toFixed(2):'0.00'}}</div>
                                <div class="title">可提现金额（元）</div>
                                <div class="tip">点击提现</div>
                            </van-col>
                        </van-row>

                    </div>
                    <!-- 上级用户 -->
                    <div class="superior" v-if="priceInfo.highLevelAccount && priceInfo.highLevelAccount.length !== 0">
                        <div class="title">推荐人</div>
                        <div class="userinfo">
                            <div class="img"><img :src="priceInfo.highLevelAccount.accountAvatar" alt=""></div>
                            <div class="info">
                                <div class="name">{{priceInfo.highLevelAccount.accountNickName || '匿名'}}</div>
                                <div class="time">{{priceInfo.highLevelAccount.accountApplyDate}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- 动动小手 -->
                    <div class="guide">
                        <p>动动小手转发就可以赚钱啦！</p>
                        <div class="button" @click="toGoodList">点我一起去赚钱</div>
                    </div>
                    <div class="swiper-btn">
                        <div class="btns">
                            <div class="btn" :class="{'btn-active': btnActive}" @click="btnActive = true">订单</div>
                            <div class="btn" :class="{'btn-active': !btnActive}" @click="btnActive = false">客户</div>
                        </div>
                    </div>
                </div>
                <!-- 资金详情 -->
                <div class="details">
                        <div class="order-content" v-if="btnActive">
                            <van-tabs v-model="active1" swipeable @change="onChange">
                                <van-tab v-for="(title, index) in orderTitles" :title="title.name" :key="index">
                                    <van-list
                                        v-model="listLoading"
                                        :finished="finished"
                                        finished-text="没有更多了"
                                        @load="onLoad()"
                                        :offset="1"
                                    >
                                        <ProCode v-for="(item, value) in data" :key="value" :pro="item"></ProCode>
                                    </van-list>
                                </van-tab>
                            </van-tabs>
                        </div>
                        <div class="client-content" v-if="!btnActive">
                            <van-tabs v-model="active2" swipeable @change="onChange">
                                <van-tab v-for="(title, index) in clientTitles" :title="title" :key="index">
                                    <!-- <ProCode></ProCode> -->
                                    <!-- {{title}} -->
                                    <van-list
                                        v-model="listLoading"
                                        :finished="finished"
                                        finished-text="没有更多了"
                                        @load="onLoad()"
                                        :offset="1"
                                    >
                                        <div class="userCard" v-for="(item, value) in data" :key="value">
                                            <div class="userinfo">
                                                <div class="img"><img :src="item.accountAvatar || defaultHeader" alt=""></div>
                                                <div class="info">
                                                    <div class="name" v-if="item.accountNickName">{{item.accountNickName}} </div>
                                                    <div class="name" v-else>{{item.accountMobilePhone | desensitization}} </div>
                                                    <div class="time" v-show="active2 === 1">{{item.accountApplyDate}}</div>
                                                </div>

                                            </div>
                                            <div class="incomesum">合计收入¥{{item.customerAllProfit}}</div>

                                        </div>
                                    </van-list>
                                </van-tab>
                            </van-tabs>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProCode from '../components/common/proCardofDistribution';
import { toastLoading, clearToastLoading } from '../utils/base/utils';
import {
    mapGetters
} from 'vuex';
export default {
    destroyed() {},
    data() {
        return {
            defaultHeader: 'http://eslink-operation-test.oss-cn-beijing.aliyuncs.com/20190611173542782951.png',
            btnActive: true,
            orderTitles: [ { name: '待到账', index: '00' }, { name: '已到账', index: '02' }, { name: '已失效', index: '01' } ],
            clientTitles: ['我的客户', '我的销售'],
            active1: 0,
            active2: 0,
            priceInfo: {
                allProfit: '',
                todayProfit: '',
                allowedDrawCash: ''
            },
            data: [],
            pageNum: 1,
            finished: true,
            listLoading: false
            // index: 0
        };
    },
    filters: {
        desensitization: function (value) {
            if (value) {
                return value.replace(/^(.{4})(?:\d+)(.{4})$/, '$1******$2');
            }
            return '';
        }
    },
    esvShow() {
        this.data = [];
        this.queryAccountAmountInfo();
        if (this.btnActive) {
            this.queryDistributionOrderList(this.active1);
            console.log('show');
        } else {
            this.queryDistributionCustomList(this.active2);
            console.log('show');
        }
    },
    methods: {
        toPage(name) {
            this.esvOpenPage(name);
        },
        toGoodList() {
            this.ESVStorage.putSavedValue('id', '-1', () => {
                this.esvOpenPage({ name: 'OPGoodlist', params: { retailStoreProductFlag: 1 } });
            });
        },
        queryAccountAmountInfo() {
            const ths = this;
            this.$doRequest(
                {
                    url: '/account/queryAccountAmountInfo',
                    params: { merchantInfo: JSON.stringify(this.merchantInfoSwitch) },
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function (data) {
                    ths.priceInfo = { ...data.result };
                }
            );
        },
        trueIndex(index) {
            const ths = this;
            for (let i = 0; i < ths.orderTitles.length; i++) {
                const item = ths.orderTitles[i];
                if (i === index) {
                    return item.index;
                }
            }
        },
        queryDistributionOrderList(status) {
            const ths = this;
            status = this.trueIndex(status);
            const params = { distributionStatus: status, pageNum: ths.pageNum, pageSize: 5, merchantInfo: JSON.stringify(this.merchantInfoSwitch) };
            this.$doRequest(
                {
                    url: '/account/queryDistributionOrderList',
                    params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function (data) {
                    ths.queryAccountAmountInfo();
                    ths.listLoading = false;
                    ths.data = [...ths.data, ...data.result.list];
                    if (ths.data.length < data.result.total) {
                        ths.finished = false;
                    } else {
                        ths.finished = true;
                    }
                }
            );
        },
        queryDistributionCustomList(status) {
            const ths = this;
            const params = { type: status + 1, pageNum: ths.pageNum, pageSize: 5, merchantInfo: JSON.stringify(this.merchantInfoSwitch) };
            this.$doRequest(
                {
                    url: '/account/queryDistributionCustomList',
                    params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function (data) {
                    ths.listLoading = false;
                    ths.queryAccountAmountInfo();
                    ths.data = [...ths.data, ...data.result.list];
                    if (ths.data.length < data.result.total) {
                        ths.finished = false;
                    } else {
                        ths.finished = true;
                    }
                }
            );
        },
        onLoad() {
            // console.log(this.index);

            this.pageNum++;
            this.listLoading = true;
            this.$nextTick(() => {
                if (this.btnActive) {
                    // this.trueIndex(this.index)
                    this.queryDistributionOrderList(this.active1);
                    console.log('load');
                } else {
                    this.queryDistributionCustomList(this.active2);
                    console.log('load');
                }
            });

            // console.log(this.index);
        },
        onChange(index, title) {
            // this.index = index;
            this.pageNum = 1;
            // alert(this.pageNum);

            this.listLoading = true;
            this.finished = false;

            this.data = [];
            if (this.btnActive) {
                // this.trueIndex(this.index)
                this.queryDistributionOrderList(index);
                console.log('change');
            } else {
                this.queryDistributionCustomList(index);
                console.log('change');
            }

            // console.log(index);
        }
    },
    computed: {
        ...mapGetters([
            'merchantInfoSwitch'
        ])
    },
    components: {
        ProCode
    },
    watch: {
        btnActive(curVal) {
            this.data = [];
            this.pageNum = 1;
            this.finished = true;
            // this.index = 0;
            if (this.active1 === this.active2) {
                // this.active1 = 0;
                if (curVal) {
                    this.queryDistributionOrderList(this.active1);
                    console.log('watch');
                } else {
                    this.queryDistributionCustomList(this.active2);
                    console.log('watch');
                }
            }
        }
    }
};
</script>

<style lang="scss">
    #page_Container {
        height: 100%;
        color: #414141;
        // >div { background-color: #fff;}
        .details {
            height: calc(100% - 194px);
            .client-content {
                height: 100%;
                .userCard {
                    font-size: 14px;
                    color: #414141;
                    display: flex;
                    padding: 15px;
                    justify-content: space-between;
                    border-bottom: 1px solid #E3E2E2;
                    // line-height: 40px;

                    .incomesum {
                        line-height: 40px;
                    }
                }
            }
            .order-content {
                height: 100%;
            }
            .van-tabs--line {
                height: 100%;
            }
            .van-tabs__content .van-tab__pane{
                overflow: auto;
            }
        }
        .guide {
            // margin-top: 1px;
            font-size: 14px;
            padding: 10px 12px;
            height: 50px;
            display: flex;
            line-height: 50px;
            justify-content: space-between;
            line-height: 30px;
            p {
            }
            .button {
                background-image: linear-gradient(90deg, #FC5236 0%, #EE2E50 100%);
                border-radius: 1px;
                padding: 0 7px;
                color: #fff
            }
        }
        .income {
            height: 90px;
            text-align: center;

            .van-row, .van-col {
                height: 100%;
            }
            .van-col {
                // display: flex;
                // flex-direction: column;
                // justify-content: center;
                padding-top: 38px;
                position: relative;
                .price {
                    font-size: 16px;
                    color: #EE2E50;
                }
                .title {
                    font-size: 12px;
                }

                .tip {
                    position: absolute;
                    top: 8px;
                    right: 50%;
                    width: 70px;
                    transform: translateX(50%);
                    padding: 0 9px;
                    height: 25px;
                    line-height: 25px;
                    color: #fff;
                    border-radius: 2px;
                    background: rgba(238,46,80,0.50);
                    &::before {
                        content: '';
                        position: absolute;
                        height: 0;
                        width: 0;
                        left: 50%;
                        top: 100%;
                        transform: translateX(-50%);
                        border-width:10px;
                        border-style: solid;
                        border-color: rgba(238,46,80,0.50) transparent transparent transparent;

                        // background: rgba(238,46,80,0.50);
                    }
                }
            }
        }

        .superior {
            display: flex;
            height: 60px;
            padding: 8px 12px;
            color: #414141;
            .title {
                line-height: 44px;
                font-size: 14px;
                font-weight: 700;
                margin-right: 20px;
            }
            .info {
                .time {
                    color: #414141 !important;
                }
            }
        }

        .swiper-btn {
            width: 100%;
            display: flex;
            justify-content: center;
            // width: 140px;
            background-color: #f2f2f2;
            height: 53px;
            padding: 10px 0;
            .btns {
                height: 33px;
                display: flex;
                width: 140px;
                border-radius: 2px;
                overflow: hidden;
                font-size: 14px;
                .btn {
                    width: 70px;
                    color: #414141;
                    background-color: #fff;
                    line-height: 33px;
                    text-align: center;
                }
                .btn-active {
                    color: #fff;
                    background-color: #EE2E50;
                }
            }

        }
        .top {
            background: #fff;
        }
        .userinfo {
            display: flex;

            .img {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                overflow: hidden;
                margin-right: 10px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .info {
                display: flex;
                justify-content: center;
                flex-direction: column;
                // height: 40px;
                // display: flex
                .time {
                    font-size: 12px;
                    color: #BEBEC5;
                }
            }

        }

    }
</style>
